const routes = {
    baseUrl:'https://ling.jiuaitu.com'
}
export default routes